import {
  createContext,
  useContext,
  useState,
  type Dispatch,
  type SetStateAction,
} from "react"

interface CompanyListsContextType {
  companyLists: { id: number; name: string }[]
  setCompanyLists: Dispatch<SetStateAction<{ id: number; name: string }[]>>
}

const CompanyListsContext = createContext<CompanyListsContextType | undefined>(
  undefined,
)

export const CompanyListsProvider = ({
  initialCompanyLists,
  children,
}: {
  initialCompanyLists: { id: number; name: string }[]
  children: React.ReactNode
}) => {
  const [companyLists, setCompanyLists] = useState(initialCompanyLists)

  return (
    <CompanyListsContext.Provider value={{ companyLists, setCompanyLists }}>
      {children}
    </CompanyListsContext.Provider>
  )
}

export const useCompanyLists = () => {
  const context = useContext(CompanyListsContext)
  if (context === undefined) {
    throw new Error(
      "useCompanyLists must be used within a CompanyListsProvider",
    )
  }
  return context
}
